import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import InventoryIcon from "@mui/icons-material/Inventory";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import { RUTA_SERVICIOS, RUTA_PRODUCTOS } from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_SERVICIOS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={MenuBookIcon}
                    ruta={RUTA_SERVICIOS}
                    titulo="Servicios"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_PRODUCTOS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={InventoryIcon}
                    ruta={RUTA_PRODUCTOS}
                    titulo="Productos"
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};
export default CardSection;
